import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { fetchUpgradeConfig } from 'pricing-pages-lib/api/fetchUpgradeConfig';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { getIsFreePortalAndOwnedProducts } from 'ui-addon-upgrades/_core/common/eligibility/getIsFreePortal';
import { getPrioritizedUpgradeProductFromApiName } from 'ui-addon-upgrades/ums/getPrioritizedUpgradeProduct';
import { SCREENS } from '../../constants/tracking/Locations';
import { useAnchorLinkScroll } from '../../hooks/htmlElementHooks';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { allPurchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import ProductInfoContainer from '../common/ProductInfoContainer';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import CompareProFeatureTable from '../feature-table/CompareProFeatureTable';
import ComparePlansLink from '../suite-starter-page/ComparePlansLink';
import UpgradeModalHeroBanner from './UpgradeModalHeroBanner';

const CompareProInterstitial = () => {
  useAnchorLinkScroll();
  useTrackRetail(); // delete?

  const {
    upgradeSource
  } = getQueryParams();
  const [upgradeConfig, setUpgradeConfig] = useState();
  const [prioritizedApiName, setPrioritizedApiName] = useState();
  const [isFreePortal, setIsFreePortal] = useState();
  const [ownedProducts, setOwnedProducts] = useState();
  useDocumentTitle('default');
  useEffect(() => {
    Promise.all([fetchUpgradeConfig(upgradeSource), getIsFreePortalAndOwnedProducts()]).then(([upgradeConfigResponse, isFreePortalAndOwnedProducts]) => {
      setUpgradeConfig(upgradeConfigResponse);
      setIsFreePortal(isFreePortalAndOwnedProducts.isFreePortal);
      setOwnedProducts(isFreePortalAndOwnedProducts.ownedProducts);
    }).catch(() => setUpgradeConfig(null));
  }, [upgradeSource]);
  const purchaseMotions = useSelector(state => {
    const allPurchaseMotions = allPurchaseMotionsSelector(state);
    return allPurchaseMotions[MERCH_CARD];
  });
  useEffect(() => {
    if (upgradeConfig && purchaseMotions && ownedProducts !== undefined && isFreePortal !== undefined) {
      const recommendedHubType = upgradeConfig.recommendationResponse ? upgradeConfig.recommendationResponse.hubType : undefined;
      const apiName = getPrioritizedUpgradeProductFromApiName(upgradeConfig.apiNames, purchaseMotions.purchaseMotions, ownedProducts, isFreePortal, recommendedHubType);
      setPrioritizedApiName(apiName);
    }
  }, [upgradeConfig, purchaseMotions, ownedProducts, isFreePortal]);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.COMPARE_PROFESSIONAL
    });
  }, []);
  const isLoading = prioritizedApiName === undefined;
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "COMPARE_PROFESSIONAL_PAGE"
    }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: isLoading,
      Content: UpgradeModalHeroBanner,
      heights: [705],
      widths: ['100%'],
      contentProps: {
        upgradePointApiName: prioritizedApiName,
        upgradeConfig
      }
    }), !isLoading && /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(ProductInfoContainer, {
      style: {
        margin: 'auto'
      },
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: isLoading,
        Content: CompareProFeatureTable,
        contentProps: {
          upgradePointApiName: prioritizedApiName
        }
      })
    })]
  });
};

export default CompareProInterstitial;